import { formatCount, formatPercent } from '@/lib/format';
import type { DisplayNodes, FunnelResult } from '@/model/types';
import { DerivedNote, Note, Readout, Section } from './parts';

interface Props {
  result: FunnelResult;
  display: DisplayNodes;
  onEditSources: () => void;
}

export function ReachStage({ result, display, onEditSources }: Props) {
  return (
    <>
      <Note>
        This rate is derived, not entered. Move it by editing the conversion rates in{' '}
        <button type="button" className="link-button" onClick={onEditSources}>
          Population
        </button>
        .
      </Note>

      <Section title="Contribution by subpopulation">
        <div className="readout-grid">
          {result.subpopulations.map((sub, i) => {
            const shown = display.subpopulations[i];
            return (
              <Readout
                key={sub.id}
                label={sub.name}
                value={formatCount(shown?.reached ?? 0)}
                note={`${formatPercent(sub.reach)} of ${formatCount(shown?.count ?? 0)}`}
              />
            );
          })}
        </div>
      </Section>

      <DerivedNote
        rows={[
          ['Engaged (reached)', formatCount(display.reachedScreening)],
          ['Blended reach', formatPercent(result.rates.screeningReach)],
        ]}
      />
    </>
  );
}
